module.exports = __webpack_public_path__ + "static/img/error.c86dacd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/error.png
// module id = lJF1
// module chunks = 1